// App.js
import React from 'react';
import InteractiveScatterPlot from './components/InteractiveScatterPlot';
import './index.css';

const App = () => {
  return (
    <div style={{ padding: '0px' }}>
      <InteractiveScatterPlot />
    </div>
  );
};

export default App;